const SpecialAccessUserManageReducer = (state = {}, action) => {
  switch (action.type) {
    case "GetSpecialAccessUsersSuccess": {
      return Object.assign({}, state, {
        UsersList: action.data,
      });
      break;
    }
    case "GetSpecialAccessUsersFailure": {
      return Object.assign({}, state, {
        UsersList: action.data,
      });
      break;
    }
    case "GetSpecialAccessUserDetailsSuccess": {
      return Object.assign({}, state, {
        UserInformation: action.data,
      });
      break;
    }
    case "GetSpecialAccessUserDetailsFailure": {
      return Object.assign({}, state, {
        UserInformation: action.data,
      });
      break;
    }
    default: {
      return state;
    }
  }
};

export default SpecialAccessUserManageReducer;
